// src/components/common/BugReportDevModeFooter.tsx
// Small footer surfaced inside the `BugReportButton` expanded panel for
// platform_owner / platform_dev users. Replaces the legacy floating
// `LeadDevModeDock` that used to render at the bottom-right of every page
// panel (deleted 2026-05-27 per dev sync note `7a082628` — see
// docs/planning/desktop_layout_pass.md §5a).
//
// Renders in both states so this is the single home for the enable/disable
// path. `useDevMode` forces devMode off on every mount, so without this
// footer there's literally no way to turn dev tools (including the dev
// mobile viewport preview) back on. Bug caught on 2026-05-27 immediately
// after the first ship of this consolidation.

export type BugReportDevModeSessionInfo =
  | { ver?: number | null; expIso?: string | null }
  | null;

export type BugReportDevModeFooterProps = {
  devMode: boolean;
  sessionInfo: BugReportDevModeSessionInfo;
  onEnable: () => void;
  onDisable: () => void;
};

export function BugReportDevModeFooter({
  devMode,
  sessionInfo,
  onEnable,
  onDisable,
}: BugReportDevModeFooterProps) {
  if (devMode) {
    return (
      <div className="flex items-center justify-between gap-2 border-t border-gray-100 bg-gray-50 px-4 py-2 text-[11px] text-gray-600">
        <span>
          Dev mode on
          {sessionInfo?.ver != null ? (
            <span className="ml-1 text-gray-500">
              · ver {sessionInfo.ver}
              {sessionInfo.expIso ? ` · exp ${sessionInfo.expIso}` : ""}
            </span>
          ) : null}
        </span>
        <button
          type="button"
          onClick={onDisable}
          className="font-medium text-rose-700 underline hover:text-rose-900"
        >
          Disable
        </button>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between gap-2 border-t border-gray-100 bg-gray-50 px-4 py-2 text-[11px] text-gray-600">
      <span>Developer tools</span>
      <button
        type="button"
        onClick={onEnable}
        className="font-medium text-indigo-700 underline hover:text-indigo-900"
      >
        Enable
      </button>
    </div>
  );
}
